import { render, staticRenderFns } from "./AttendancePeriods.vue?vue&type=template&id=5f2b9c02&scoped=true"
import script from "./AttendancePeriods.vue?vue&type=script&lang=js"
export * from "./AttendancePeriods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2b9c02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
